"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.preview.title': 'Vista Previa del Tutorial',
    'tutorial.preview.introduction': 'Introducción',
    'tutorial.preview.learningSteps': 'Pasos de Aprendizaje',
    'tutorial.preview.tutorialSections': 'Secciones del Tutorial',
    'tutorial.preview.knowledgeEntries': 'entradas de conocimiento',
    'tutorial.preview.sectionPrompt': 'Prompt de la Sección',
    'tutorial.preview.knowledgeBase': 'Base de Conocimiento',
    'tutorial.preview.stepSections': 'Secciones del Paso',
    'tutorial.preview.notFound': 'Tutorial No Encontrado',
    'tutorial.preview.notFoundMessage': 'El tutorial solicitado no se pudo encontrar o no tiene permisos para verlo.',
};
